import DragonGift from 'assets/img/dragon-gift.png';

import './DragonOverlayContent.styl';
import { observer } from 'mobx-react-lite';
import { useTranslationsContext } from 'store/translations';
import { Button } from 'components/core';
import { useNavigate } from 'react-router';
import { routes } from 'utils/router';
import { useStoreContext } from 'store/app';
import { LootboxTypes } from 'src/types';

export const DragonOverlayContent = observer(() => {
    const { userState, logOperation } = useStoreContext();
    const { translate } = useTranslationsContext();
    const navigate = useNavigate();
    const dragonBoxID = userState?.unopened_bonus_lootboxes?.find((x) => x.key === LootboxTypes.DRAGON)?.id;

    return (
        <div className="dragon-gift">
            <img className="dragon-gift-image" src={DragonGift}></img>
            <div className="dragon-gift-title">{translate('dragon.gift.title')}</div>
            <div className="dragon-gift-desc">{translate('dragon.gift.desc')}</div>
            <Button
                onClick={() => {
                    logOperation('dragon_snake', 'open');
                    navigate(routes.lootbox, { state: { lootboxToOpen: dragonBoxID } });
                }}
            >
                {translate('dragon.gift.button')}
            </Button>
        </div>
    );
});
